import ModalContext from 'contexts/ModalContext'
import type { ReactElement } from 'react'
import { useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import LandingPageLoyaltyDiscountedInsuranceBenefitsModal from './LandingPageLoyaltyDiscountedInsuranceBenefitsModal'

interface Props {
  layout: 'tile' | 'row'
  benefitLabel: ReactElement
  discountPercent: number
}

function LandingPageLoyaltyDiscountedInsurance(props: Props) {
  const { layout, benefitLabel, discountPercent } = props

  const showModal = useContext(ModalContext)
  const intl = useIntl()
  const image = useMemo<App.Image>(() => ({
    id: '36fmxwdnmim0b53p9x7',
    title: intl.formatMessage({
      id: 'I1NTaUCQOVKeVKxrYaiJ',
      defaultMessage: 'Travel & Cancellation Protection',
      description: 'Alternative text fallback for the discounted insurance loyalty benefit image',
    }),
  }), [intl])

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyDiscountedInsuranceBenefitsModal
      image={image}
      discountPercent={discountPercent}
    />)
  }, [discountPercent, image, showModal])

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="discounted_insurance"
    heading={intl.formatMessage(
      {
        defaultMessage: '{discountPercent}% off Travel & Cancellation Protection',
        id: 'R_zby_zxExifRXeLLAdT',
        description: 'Heading for loyalty discounted insurance benefit tile showing percentage discount',
      },
      { discountPercent },
    )}
    subtitle={benefitLabel}
    onClick={handleDetailsClick}
  />
}

export default LandingPageLoyaltyDiscountedInsurance
